
import { AccessTimeOutlined, HighlightOff, CheckCircleOutline, LocalShipping } from '@mui/icons-material'
import { getSystemEnv } from './env'
export const IMG_URL: string = getSystemEnv().IMG_URL
export const DOMAIN: string = getSystemEnv().DOMAIN
export const NETWORK_COVERAGE_URL: string = getSystemEnv().NETWORK_COVERAGE_URL
export const BRAND_GUIDE_URL: string = getSystemEnv().BRAND_GUIDE_URL
export const phoneRegex = /^(99|95|94|85)\d{6}$/
export const phoneRegex2 = /^\d{8}$/
export const emailRegex = /^[A-Za-z0-9_!#$%&'*+=?`{|}~^.-]+@[A-Za-z0-9.-]+[.]{1}[A-Za-z0-9.-]+$/
export const onlyLetterAndNumber = /^[А-ЯЁӨҮ0-9]*$/
export const registerNumber = /^[А-ЯЁӨҮа-яёөү]{2}[0-9]{8}$/
export const onlyCyrill = /[А-ЯЁӨҮа-яёөү]/

export interface BottomMenuItem {
  name_mn: string
  name_en?: string
  icon: string
  activeIcon: string
  pathname?: string
}
export const BottomMenuItems: BottomMenuItem[] = [
  {
    name_mn: 'Дэлгүүр',
    name_en: 'Shop',
    icon: '/uploads/icons/shopping-bag.svg',
    activeIcon: '/uploads/icons/shop-active.svg',
    pathname: '/shop'
  },
  {
    name_mn: 'Сагс',
    name_en: 'Cart',
    icon: '/uploads/icons/shopping-cart.svg',
    activeIcon: '/uploads/icons/cart-active.svg',
    pathname: '/cart'
  },
  {
    name_mn: 'Захиалга',
    name_en: 'Orders',
    icon: '/uploads/icons/shipping.svg',
    activeIcon: '/uploads/icons/shipping-active.svg',
    pathname: '/order'
  }
  // {
  //   name_mn: 'Профайл',
  //   name_en: 'Profile',
  //   icon: user,
  //   activeIcon: userActive,
  //   pathname: '/user'
  // }

]

interface OrderStatusDescriptions {
  mn: string
  en: string
  icon: any
  iconColor: string
  bgColor: string
  textColor: string
  borderColor: string
}
export const OrderStatusDesc: Record<string, OrderStatusDescriptions> = {
  PLACED: {
    mn: 'Захиалга баталгаажсан',
    en: 'Order placed',
    icon: AccessTimeOutlined,
    iconColor: '#F4A610',
    bgColor: '#FFF0D2',
    textColor: '#6C4A06',
    borderColor: '#FFDD9B'
  },
  SHIPPED: {
    mn: 'Хүргэлтэд гарсан',
    en: 'Shipped',
    icon: LocalShipping,
    iconColor: '#F4A610',
    bgColor: '#FFF0D2',
    textColor: '#6C4A06',
    borderColor: '#FFDD9B'
  },
  COMPLETED: {
    mn: 'Амжилттай хүргэгдсэн',
    en: 'Delivered',
    icon: CheckCircleOutline,
    iconColor: '#2FA84F',
    bgColor: '#D0F0D9',
    textColor: '#103C1C',
    borderColor: '#91D1A3'
  },
  CANCELED: {
    mn: 'Цуцлагдсан',
    en: 'Canceled',
    icon: HighlightOff,
    iconColor: '#ED1C24',
    bgColor: '#FFDDDE',
    textColor: '#79080D',
    borderColor: '#FF9599'
  }
}

export interface CESItem {
  icon: string
  value: number
  mn: string
  en: string
}
export const CESItems: CESItem[] = [
  {
    icon: '/uploads/icons/ces/7.svg',
    value: 7,
    mn: 'Үнэхээр хялбар',
    en: 'Pretty easy'
  },
  {
    icon: '/uploads/icons/ces/6.svg',
    value: 6,
    mn: 'Хялбар',
    en: 'Easy'
  },
  {
    icon: '/uploads/icons/ces/5.svg',
    value: 5,
    mn: 'Дундаж',
    en: 'Normal'
  },
  {
    icon: '/uploads/icons/ces/4.svg',
    value: 4,
    mn: 'Мэдэхгүй',
    en: "Don't know"
  },
  {
    icon: '/uploads/icons/ces/3.svg',
    value: 3,
    mn: 'Хэцүүвтэр',
    en: 'Struggling'
  },
  {
    icon: '/uploads/icons/ces/2.svg',
    value: 2,
    mn: 'Хэцүү',
    en: 'Hard'
  },
  {
    icon: '/uploads/icons/ces/1.svg',
    value: 1,
    mn: 'Үнэхээр хэцүү',
    en: 'Preddy hard'
  }
]
